// src/components/ads/AdPlacement/AdPlacement.jsx
import React from "react";
import { AD_PLACEMENTS } from "../adConfig/adPlacements";
import AdManager from "../adManager/adManager";
import { useMediaQuery } from "react-responsive";

const AdPlacement = ({
  type,
  position,
  index = null,
  className = "",
  ...adProps
}) => {
  const isMedium = useMediaQuery({
    minWidth: 769,
    maxWidth: 1025,
  });
  const isMobile = useMediaQuery({ maxWidth: 768.5 });
  const getPlacementConfig = () => {
    switch (type) {
      case "products":
        switch (position) {
          // Ad below filters
          case "left-bottom":
            return {
              placementName: AD_PLACEMENTS.SIDEBAR.DESKTOP_LEFT,
              dimensions: "300x250",
              className: `${className}`,
            };

          //  Ad after every 5th record in each page
          case "banner ad (6th tile":
            return {
              placementName: AD_PLACEMENTS.LIST_VIEW.AFTER_EVERY_5_RECORDS,
              dimensions: "950x152",
              className: `${className}`,
            };

          // Ad above pagination in each page
          case "bottom":
            return {
              placementName: AD_PLACEMENTS.LIST_VIEW.BOTTOM,
              dimensions: "950x152",
              className: `${className}`,
            };

          // Ad  in mobile
          case "mobile":
            return {
              placementName: "tower ad",
              dimensions: "200x233",
              className: `${className}`,
            };
          // GRID VIEW (6th tile)
          case "grid view (6th tile)":
            return {
              placementName: AD_PLACEMENTS.GRID_VIEW.GRID_6TH_TILE,
              width: "230px",
              height: isMobile ? "100%" : "65%",
              className: `grid-sixth-tile ${className}`,
            };

          // No default case
          default:
            return null;
        }
    }
    return null;
  };

  const config = getPlacementConfig();

  return (
    <div
      className={`ad-placement ${config?.className}`}
      style={
        position === "grid view (6th tile)" ? { height: config?.height } : {}
      }
    >
      <AdManager
        placementName={config?.placementName}
        dimensions={config?.dimensions}
        targeting={config?.targeting}
        width={config?.width}
        height={config?.height}
        {...adProps}
      />
    </div>
  );
};

export default AdPlacement;
